import React from 'react';

import { isEmpty } from 'ramda';
import { FormProvider } from 'react-hook-form';

import { SceneFooter } from '../../../SceneFooter';
import { SceneLoaderWrapper } from '../../../SceneLoaderWrapper';
import { CommonModalData } from '../../../types';
import { useDetailsFormProps } from '../../shared';
import * as types from '../../types';
import { WATCHED_COMMON_FIELD_KEYS } from './constants';
import { CommonForm } from './Form';
import { handleFormValues } from './functions';
import { useCommonForm } from './useCommonForm';

type Props = {
  modalData: CommonModalData;
  onSubmit: (fieldValues: types.CommonFormValues) => Promise<void>;
  type: types.CommonFormValues['type'];
};

function CommonFormScene({ modalData, onSubmit, type }: Props) {
  const methods = useCommonForm({ modalData, type });
  const { setDetailsFormProps } = modalData;
  const { formState, watch } = methods;

  const loading = formState.isSubmitting;
  const watchFormFields = watch(WATCHED_COMMON_FIELD_KEYS);
  const isFormFilled = watchFormFields.some((field) => !!field && !isEmpty(field));

  useDetailsFormProps({ isFormFilled, isDirty: formState.isDirty, setDetailsFormProps });

  const handleSubmit = async (formValues: types.CommonFormValues) => {
    const handledValues = handleFormValues(formValues);
    await onSubmit(handledValues);
  };

  return (
    <SceneLoaderWrapper loading={loading}>
      <FormProvider {...methods}>
        <CommonForm type={type} />

        <SceneFooter onSubmit={methods.handleSubmit(handleSubmit)} loading={loading} />
      </FormProvider>
    </SceneLoaderWrapper>
  );
}

export { CommonFormScene };
